const initialState = {
  status: "invalid",
  filters: {
    open: true,
    query: {},
  },
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "PACKAGES_TOGGLE_FILTERS":
      return {
        ...state,
        filters: {
          ...state.filters,
          open: !state.filters.open,
        },
      };
    case "PACKAGES_RESET_FILTERS":
      return {
        ...state,
        filters: {
          open: true,
          query: {},
        },
      };
    case "PACKAGES_SET_FILTERS_QUERY":
      return {
        ...state,
        filters: { ...state.filters, query: action.query },
      };
    case "PACKAGES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "PACKAGES_SEARCHING":
      return {
        ...state,
        status: "searching",
      };
    case "PACKAGES_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
        meta: action.meta,
      };
    case "PACKAGES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
